<template>
    <v-card>
        <v-data-table :items="contatti" :headers="headers">
            <template v-slot:[`item.allegati`]="{ item }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            @click="openAllegati(item)"
                            small
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon color="primary"> mdi-paperclip </v-icon>
                        </v-btn>
                    </template>
                    <span>Allegati </span>
                </v-tooltip>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
export default {
    data() {
        return {
            contatti: [],
            headers: [
                {
                    text: "Allegati",
                    value: "allegati",
                },
                {
                    text: "Nominativo",
                    value: "nominativo",
                },
            ],
        };
    },
    props: {
        id_anagrafica: { type: Number, default: -1 },
    },
    async mounted() {
        await this.getContatti();
    },
    methods: {
        openAllegati(arg){
            this.$emit("openAllegati", arg);
        },
        async getContatti() {
            var getAziende = {
                controller: "contabilita",
                method: "POST",
                richiesta: {
                    action: "getanagrafica",
                    id_anagrafica: this.id_anagrafica,
                    token: localStorage.user_token,
                },
            };

            await this.$store.dispatch("api6", getAziende).then((res) => {
                this.contatti = res.data.result.anagrafica[0].contatti;
            });
        },
    },
};
</script>
